var map = {
  "./cs.json": [
    "Tgd",
    [
      "h7v"
    ]
  ],
  "./en.json": [
    "us",
    [
      876
    ]
  ],
  "./pl.json": [
    "xLP",
    [
      "rak"
    ]
  ],
  "./ru.json": [
    "BxC",
    [
      "7o"
    ]
  ],
  "./tr.json": [
    "jb",
    [
      "px"
    ]
  ],
  "./ja.json": [
    "n0",
    [
      "pd"
    ]
  ],
  "./zh.json": [
    "Jba",
    [
      "rz"
    ]
  ],
  "./pt-br.json": [
    "NGq",
    [
      "fu"
    ]
  ],
  "./de.json": [
    "jl",
    [
      "l47"
    ]
  ],
  "./es.json": [
    "cb",
    [
      "us"
    ]
  ],
  "./fr.json": [
    "gJ",
    [
      "ul"
    ]
  ],
  "./it.json": [
    "Pp",
    [
      "5g"
    ]
  ],
  "./ko.json": [
    "nQz",
    [
      "h3"
    ]
  ],
  "./pt.json": [
    "Di",
    [
      "p1"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "TS";
module.exports = __rspack_async_context;
